import { Fragment } from 'react';
import { Tooltip } from 'ui/tooltip';
import { Badge, BADGE_VARIANTS } from 'ui/badge';

import { BadgeContainer } from './Styled';
import { BADGE_VARIANTS_FOR_CAMPAIGN_STATUSES } from '../../campaignIndex/constants';
import { SnippetUsage, MESSAGE_MEDIUMS } from '../types';

type Props = {
  result: SnippetUsage;
};

export const UsageCampaignCell = ({ result }: Props) => {
  const statusBadgeVariant = result.campaignState
    ? BADGE_VARIANTS_FOR_CAMPAIGN_STATUSES[result.campaignState]
    : null;

  const isNestedSnippet =
    result.messageMedium === MESSAGE_MEDIUMS.SNIPPET &&
    result.resultType === MESSAGE_MEDIUMS.SNIPPET;

  return (
    <Fragment key={result.id}>
      {statusBadgeVariant ? (
        <BadgeContainer>
          <Badge variant={statusBadgeVariant}>{result.campaignState}</Badge>
        </BadgeContainer>
      ) : (
        <BadgeContainer>
          <Tooltip
            isEnabled={isNestedSnippet}
            tooltipContent={<div>Look up where this snippet is used to determine its status.</div>}
          >
            <Badge variant={BADGE_VARIANTS.INACTIVE}>
              {isNestedSnippet ? 'Unknown' : 'Inactive'}
            </Badge>
          </Tooltip>
        </BadgeContainer>
      )}
    </Fragment>
  );
};
